import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';
import { InvoiceModel } from '@data-layer/models/entry-summaries';

@Injectable({
  providedIn: 'root',
})
export class InvoicesCustomsBrokerManagementRepository {
  constructor(private apiService: ApiService) {}

  public get(invoiceId: number): Observable<InvoiceModel> {
    return this.apiService.get<InvoiceModel>(`${environment.url.prefixCustoms}v2/management/customs-broker/invoices/${invoiceId}`);
  }

  public create(shipmentId: number, invoice: Partial<InvoiceModel>): Observable<InvoiceModel> {
    return this.apiService.post<InvoiceModel>(
      `${environment.url.prefixCustoms}v2/management/customs-broker/shipments/${shipmentId}/invoices`,
      invoice,
    );
  }

  public update(invoiceId: number, invoice: Partial<InvoiceModel>): Observable<InvoiceModel> {
    return this.apiService.put<InvoiceModel>(`${environment.url.prefixCustoms}v2/management/customs-broker/invoices/${invoiceId}`, invoice);
  }

  public delete(invoiceId: number): Observable<never> {
    return this.apiService.delete(`${environment.url.prefixCustoms}v2/management/customs-broker/invoices/${invoiceId}`);
  }
}
